<div adaptToolbarContent>
    <button adaptButtonIcon="add"
            *adaptIfAuthorised="CulturalLeadershipFrameworkAuthService.ConfigureCohorts"
            data-test="create-cohort-button"
            (click)="addCohort()">
        Create new
        {{ culturalLeadershipConfiguration?.secondaryCollectionName }}
    </button>
    <button adaptButton="deleteLink"
            *adaptIfAuthorised="CulturalLeadershipFrameworkAuthService.ConfigureCohorts"
            adaptTooltip="Excluded people are hidden within the cultural leadership framework and are not included in cultural statistics"
            data-test="exclude-people-button"
            (click)="excludePeople()">Manage excluded people</button>
</div>

<dx-data-grid [allowColumnResizing]="true"
              [allowColumnReordering]="true"
              [wordWrapEnabled]="true"
              [rowAlternationEnabled]="true"
              [hoverStateEnabled]="true"
              [showRowLines]="true"
              [showBorders]="true"
              [dataSource]="gridData"
              (onCellPrepared)="onCellPrepared($event)"
              noDataText="No Catchup Activity found"
              data-test="clf-grid"
              [stateStoring]="dxGridWrapperHelper.stateStoringOptions"
              (onInitialized)="onGridInitialized($event)">
    <dxo-data-grid-column-fixing [enabled]="true"> </dxo-data-grid-column-fixing>
    <dxo-data-grid-column-chooser [enabled]="true"></dxo-data-grid-column-chooser>
    <dxo-data-grid-pager [showPageSizeSelector]="true"
                         [allowedPageSizes]="[10, 25, 50, 100, 250]"> </dxo-data-grid-pager>
    <dxo-data-grid-paging [pageSize]="25"> </dxo-data-grid-paging>
    <dxo-data-grid-scrolling [useNative]="false"> </dxo-data-grid-scrolling>
    <dxo-data-grid-header-filter [visible]="true"> </dxo-data-grid-header-filter>
    <dxo-data-grid-filter-row [visible]="true"> </dxo-data-grid-filter-row>
    <dxo-data-grid-group-panel [visible]="true"> </dxo-data-grid-group-panel>
    <dxo-data-grid-grouping [autoExpandAll]="true"> </dxo-data-grid-grouping>
    <dxo-data-grid-export [enabled]="true"
                          fileName="CatchupActivity"> </dxo-data-grid-export>
    <dxo-data-grid-load-panel [enabled]="true"> </dxo-data-grid-load-panel>

    <!-- Columns -->
    <dxi-data-grid-column caption="Person"
                          dataField="person.fullName"
                          dataType="string"
                          cellTemplate="personCellTemplate"
                          [sortIndex]="2"
                          sortOrder="asc"
                          width="250"></dxi-data-grid-column>

    <dxi-data-grid-column [caption]="culturalLeadershipConfiguration?.primaryName"
                          [calculateCellValue]="calculateCulturalLeadersCellValue"
                          [calculateGroupValue]="calculateCulturalLeadersGroupValue"
                          [customizeText]="culturalLeadersCustomizeText"
                          dataType="string"
                          dataField="dummy_culturalleader"
                          cellTemplate="culturalLeaderCellTemplate"
                          groupCellTemplate="culturalLeaderGroupCellTemplate"
                          [groupIndex]="0"
                          [allowSorting]="true"
                          [allowGrouping]="true"
                          [allowFiltering]="true">
        <dxo-data-grid-header-filter [dataSource]="culturalLeadersHeaderItems"></dxo-data-grid-header-filter>
    </dxi-data-grid-column>

    <dxi-data-grid-column caption="Supporting"
                          dataField="isSupporting"
                          dataType="boolean"
                          falseText="False"
                          trueText="True"
                          sortOrder="asc"
                          [sortIndex]="1"
                          [visible]="false"></dxi-data-grid-column>

    @if (ciAccess || cvtAccess) {
        <dxi-data-grid-column caption="Status"
                              [calculateCellValue]="culturalLeadershipUiService.calculateStatusCellValue"
                              dataType="string"
                              dataField="dummy_status"
                              [cellTemplate]="culturalLeadershipUiService.getStatusCellTemplate"
                              [allowSorting]="true"
                              [allowGrouping]="true"
                              [allowFiltering]="true"
                              [width]="180">
            <dxo-data-grid-header-filter [dataSource]="culturalLeadershipHeaderOptions"> </dxo-data-grid-header-filter>
        </dxi-data-grid-column>

        <dxi-data-grid-column caption="Next catch-up"
                              dataField="nextCatchup"
                              dataType="date"
                              cellTemplate="nextCatchupCellTemplate"
                              [format]="dateFormat"
                              [width]="180"> </dxi-data-grid-column>
    }

    @if (ciAccess) {
        <dxi-data-grid-column caption="Cultural Index"
                              dataField="culturalIndex.value"
                              dataType="number"
                              [customizeText]="culturalIndexUiService.customiseValueCellText"
                              cellTemplate="culturalIndexCellTemplate">
            <dxo-data-grid-header-filter [dataSource]="culturalIndexHeaderOptions"> </dxo-data-grid-header-filter>
        </dxi-data-grid-column>

        <dxi-data-grid-column caption="CI direction"
                              dataField="culturalIndex.direction"
                              dataType="string"
                              cellTemplate="culturalIndexCellTemplate">
            <dxo-data-grid-lookup [dataSource]="culturalIndexService.directions"
                                  valueExpr="id"
                                  displayExpr="label"> </dxo-data-grid-lookup>
        </dxi-data-grid-column>

        <dxi-data-grid-column caption="CI date"
                              dataField="culturalIndex.creationDate"
                              dataType="date"
                              cellTemplate="culturalIndexCellTemplate"
                              [format]="dateFormat"> </dxi-data-grid-column>

        <dxi-data-grid-column caption="Next CI date"
                              dataField="nextCI"
                              dataType="date"
                              cellTemplate="nextCICellTemplate"
                              [format]="dateFormat"
                              [visible]="false"> </dxi-data-grid-column>

        @if (allowCulturalIndexNotes) {
            <dxi-data-grid-column caption="CI Notes"
                                  dataField="culturalIndex.notes"
                                  dataType="string"
                                  cellTemplate="culturalIndexNotesCellTemplate"
                                  [encodeHtml]="false"
                                  [visible]="false"> </dxi-data-grid-column>
        }
    }

    @if (cvtAccess) {
        <dxi-data-grid-column caption="Career Valuation"
                              dataField="careerValuation.extensions.actualTotal"
                              dataType="number"
                              cellTemplate="careerValuationCellTemplate">
            <dxo-data-grid-header-filter [dataSource]="careerValuationHeaderOptions"> </dxo-data-grid-header-filter>
        </dxi-data-grid-column>

        <dxi-data-grid-column caption="CV date"
                              dataField="careerValuation.creationDate"
                              dataType="date"
                              cellTemplate="careerValuationDateCellTemplate"
                              [format]="dateFormat"> </dxi-data-grid-column>

        <dxi-data-grid-column caption="Next CV date"
                              dataField="nextCVT"
                              dataType="date"
                              cellTemplate="nextCVTCellTemplate"
                              [format]="dateFormat"
                              [visible]="false"> </dxi-data-grid-column>

        @if (allowCareerValuationNotes) {
            <dxi-data-grid-column caption="CV Notes"
                                  dataField="careerValuation.notes"
                                  dataType="string"
                                  cellTemplate="careerValuationNotesCellTemplate"
                                  [encodeHtml]="false"
                                  [visible]="false"> </dxi-data-grid-column>
        }
    }

    <!-- Templates -->
    <div *dxTemplate="let item of 'personCellTemplate'"
         class="d-flex align-items-center">
        @if (asCulturalLeadershipPersonalAnalysisData(item.data); as data) {
            <adapt-link-person [person]="data.person"
                               [showImage]="true"
                               imageSize="sm"
                               [preventWrap]="true"></adapt-link-person>
            @if (data.culturalLeader && data.isSupporting) {
                <span [adaptTooltip]="SupportingMemberTooltip"
                      class="fal fa-circle fa-xs supporting-icon p-2"></span>
            }
        }
    </div>

    <div *dxTemplate="let item of 'culturalIndexCellTemplate'">
        @if (asCulturalLeadershipPersonalAnalysisData(item.data); as data) {
            @if (data.culturalIndex) {
                <div>{{ item.text }}</div>
            }
            @if (!data.currentPersonHasCulturalIndexAccess) {
                <ng-container *ngTemplateOutlet="accessDeniedTemplate"></ng-container>
            }
        }
    </div>

    <div *dxTemplate="let item of 'culturalIndexNotesCellTemplate'">
        @if (asCulturalLeadershipPersonalAnalysisData(item.data); as data) {
            @if (data.culturalIndex && data.currentPersonHasCulturalIndexAccess) {
                <div [innerHTML]="data.culturalIndex.notes"></div>
            }
            @if (!data.currentPersonHasCulturalIndexAccess) {
                <ng-container *ngTemplateOutlet="accessDeniedTemplate"></ng-container>
            }
        }
    </div>

    <div *dxTemplate="let item of 'careerValuationCellTemplate'"
         data-test="career-valuation-cell">
        @if (asCulturalLeadershipPersonalAnalysisData(item.data); as data) {
            @if (data.careerValuation) {
                <div>
                    {{ data.careerValuation.extensions.actualTotal }}%
                    <i class="ms-2 career-valuation-launch fal fa-external-link-alt"
                       (click)="launchPersonCareerValuation(data.careerValuation)"
                       adaptTooltip="Click for more details"></i>
                </div>
            }
            @if (!data.currentPersonHasCareerValuationAccess) {
                <ng-container *ngTemplateOutlet="accessDeniedTemplate"></ng-container>
            }
        }
    </div>

    <div *dxTemplate="let item of 'careerValuationDateCellTemplate'">
        @if (asCulturalLeadershipPersonalAnalysisData(item.data); as data) {
            @if (data.careerValuation) {
                <div>{{ item.text }}</div>
            }
            @if (!data.currentPersonHasCareerValuationAccess) {
                <ng-container *ngTemplateOutlet="accessDeniedTemplate"></ng-container>
            }
        }
    </div>

    <div *dxTemplate="let item of 'careerValuationNotesCellTemplate'">
        @if (asCulturalLeadershipPersonalAnalysisData(item.data); as data) {
            @if (data.careerValuation && data.currentPersonHasCareerValuationAccess) {
                <div [innerHTML]="data.careerValuation.notes"></div>
            }
            @if (!data.currentPersonHasCareerValuationAccess) {
                <ng-container *ngTemplateOutlet="accessDeniedTemplate"></ng-container>
            }
        }
    </div>

    <div *dxTemplate="let item of 'nextCatchupCellTemplate'"
         class="d-flex flex-column"
         #tooltipTarget>
        @if (asCulturalLeadershipPersonalAnalysisData(item.data); as data) {
            @if (!data.nextCatchup) {
                No catch-up scheduled
                @if (!data.isSupporting || !data.hasPrimaryCulturalLeader) {
                    <div class="d-flex flex-row flex-wrap column-gap-2 secondary-activity">
                        @if (cvtAccess) {
                            <ng-container *ngTemplateOutlet="
                                    scheduleButtonTemplate;
                                    context: {
                                        type: CulturalActivityType.CareerValuation,
                                    }
                                "></ng-container>
                        }

                        @if (ciAccess) {
                            <ng-container *ngTemplateOutlet="
                                    scheduleButtonTemplate;
                                    context: {
                                        type: CulturalActivityType.CulturalIndex,
                                    }
                                "></ng-container>
                        }

                        <ng-template #scheduleButtonTemplate
                                     let-type="type">
                            <button adaptButton="addLink"
                                    (click)="scheduleActivity(type, data)"
                                    [attr.data-test]="`schedule-${type.toLocaleLowerCase()}-activity-button`">Schedule
                                {{ getFullTypeName(type) }}</button>
                        </ng-template>
                    </div>
                }
            } @else {
                @let primaryType = getPrimaryType(data);
        @if (cvtAccess) {
                    <div class="d-flex gap-1 align-items-center"
                         [ngClass]="{
                            'secondary-activity order-1': primaryType === CulturalActivityType.CulturalIndex && ciAccess,
                        }">
                        <ng-container *ngTemplateOutlet="
                                catchupTypeCellTemplate;
                                context: {
                                    item,
                                    type: CulturalActivityType.CareerValuation,
                                    showType: ciAccess,
                                }
                            "></ng-container>
                    </div>
                }

                @if (ciAccess) {
                    <div class="d-flex gap-1 align-items-center"
                         [ngClass]="{
                            'secondary-activity order-1': primaryType === CulturalActivityType.CareerValuation && cvtAccess,
                        }">
                        <ng-container *ngTemplateOutlet="
                                catchupTypeCellTemplate;
                                context: {
                                    item,
                                    type: CulturalActivityType.CulturalIndex,
                                    showType: cvtAccess,
                                }
                            "></ng-container>
                    </div>
                }
            }
        }
    </div>

    <div *dxTemplate="let item of 'nextCICellTemplate'"
         class="d-flex gap-1 align-items-center"
         #tooltipTarget>
        <ng-container *ngTemplateOutlet="
                catchupTypeCellTemplate;
                context: {
                    item,
                    type: CulturalActivityType.CulturalIndex,
                    tooltipTarget,
                }
            "></ng-container>
    </div>

    <div *dxTemplate="let item of 'nextCVTCellTemplate'"
         class="d-flex gap-1 align-items-center"
         #tooltipTarget>
        <ng-container *ngTemplateOutlet="
                catchupTypeCellTemplate;
                context: {
                    item,
                    type: CulturalActivityType.CareerValuation,
                    tooltipTarget,
                }
            "></ng-container>
    </div>

    <ng-template #catchupTypeCellTemplate
                 let-item="item"
                 let-type="type"
                 let-tooltipTarget="tooltipTarget"
                 let-showType="showType">
        @if (asCulturalLeadershipPersonalAnalysisData(item.data); as data) {
            @let activity = type === CulturalActivityType.CareerValuation ? asCulturalActivity(data.nextCVTActivity) : asCulturalActivity(data.nextCIActivity);
        @let nextCatchupDate = type === CulturalActivityType.CareerValuation ? data.nextCVT : data.nextCI;
        @let isSuggestedDate = !activity && !!nextCatchupDate;
        @let fullTypeName = getFullTypeName(type);

        <div [adaptTooltip]="isSuggestedDate ? `This is a suggested date, there is no ${fullTypeName} scheduled for this person yet.` :
            null" tooltipPlacement="top-left" [class.opacity-50]="isSuggestedDate">
            @if (showType) {
                <span class="text-muted">{{ getTypeName(type) }}:</span>
            }
            {{ nextCatchupDate ? (nextCatchupDate | adaptDate) : "No catch-up scheduled" }}
            </div>

            @if (activity) {
                <div class="ms-auto d-flex gap-1 align-items-center">
                    @if (activity.extensions.hasRescheduled) {
                        <adapt-activity-rescheduled-info [activity]="activity"
                                                         [tooltipTarget]="tooltipTarget"
                                                         class="ms-1"></adapt-activity-rescheduled-info>
                    }
                    <button class="btn btn-link"
                            adaptButtonIcon="fal fa-fw fa-edit"
                            adaptTooltip="Reschedule {{ fullTypeName }}"
                            (click)="rescheduleActivity(activity)"
                            [attr.data-test]="`reschedule-${type.toLocaleLowerCase()}-activity-button`"></button>
                </div>
            } @else if (!data.isSupporting || !data.hasPrimaryCulturalLeader) {
                <button class="ms-auto"
                        adaptButton="addLink"
                        adaptTooltip="Schedule {{ fullTypeName }}"
                        (click)="scheduleActivity(type, data)"
                        [attr.data-test]="`schedule-${type.toLocaleLowerCase()}-activity-button`"></button>
            }
        }
    </ng-template>

    <div *dxTemplate="let item of 'culturalLeaderCellTemplate'">
        @if (asCulturalLeadershipPersonalAnalysisData(item.data); as data) {
            <adapt-link-person [person]="data.culturalLeader"
                               [preventWrap]="true"
                               nullValueText="None allocated"></adapt-link-person>
        }
    </div>
    <div *dxTemplate="let item of 'culturalLeaderGroupCellTemplate'">
        @if (!!item.value) {
            {{ culturalLeadershipConfiguration?.primaryName }}:
            <adapt-link-person [personId]="item.value"
                               [preventWrap]="true"></adapt-link-person>
            <button class="ms-2"
                    adaptButton="editLink"
                    data-test="edit-cohort"
                    *adaptIfAuthorised="CulturalLeadershipFrameworkAuthService.ConfigureCohorts"
                    adaptTooltip="Edit {{ culturalLeadershipConfiguration?.secondaryCollectionName }}"
                    (click)="editCohort(item.value)"></button>
        } @else {
            No {{ culturalLeadershipConfiguration?.primaryName }}
            <button class="ms-2"
                    adaptButton="addLink"
                    *adaptIfAuthorised="CulturalLeadershipFrameworkAuthService.ConfigureCohorts"
                    (click)="addCohort()">
                Create new
                {{ culturalLeadershipConfiguration?.secondaryCollectionName }}
            </button>
        }
    </div>

    <ng-template #accessDeniedTemplate>
        <i class="fa fa-fw fa-ban"
           adaptTooltip="You do not have access to view this data"></i>
    </ng-template>
</dx-data-grid>
